/**
 * Problem Details の `type` フィールドに用いるエラー識別子。
 * RFC 7807 準拠。RFC 8141 (URN) 形式でドメイン非依存に保つ。
 * フロント・サーバで同じ定数を参照し、識別子の重複・乖離を防ぐ。
 */
export const ProblemTypes = {
  CSRF_TOKEN_MISMATCH: "urn:faqrun:error:csrf-token-mismatch",
  /** ダウングレード予約: 更新日まで 24 時間以内のため予約不可 */
  DOWNGRADE_WITHIN_24H: "urn:faqrun:error:downgrade-within-24h",
  /** アップグレード: 未払い open invoice が残っているため受付不可 */
  OPEN_INVOICE_EXISTS: "urn:faqrun:error:open-invoice-exists",
} as const;

export type ProblemType = (typeof ProblemTypes)[keyof typeof ProblemTypes];
